import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Card, CardContent, CardHeader, Avatar, Typography, TextField, Checkbox, FormControlLabel, Button, Grid } from '@mui/material';
import axios from 'axios';
import ImageUpload from "../../components/ImageUpload";

export default function Update() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const {
    id,
    firstName,
    lastName,
    position,
    email,
    phoneNumber,
    employmentType,
    isActive,
    department,
    notes
  } = state;

  const [ime, setIme] = useState(firstName || "");
  const [prezime, setPrezime] = useState(lastName || "");
  const [pozicija, setPozicija] = useState(position || "");
  const [mail, setMail] = useState(email || "");
  const [telefon, setTelefon] = useState(phoneNumber || "");
  const [tipZaposlenja, setTipZaposlenja] = useState(employmentType || "");
  const [aktivan, setAktivan] = useState(isActive || false);
  const [odjel, setOdjel] = useState(department || "");
  const [napomena, setNapomena] = useState(notes || "");

  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;

  const updateAPIData = () => {
    axios.put(`${SERVER_URL}/api/workers/${id}`, {
      firstName: ime,
      lastName: prezime,
      position: pozicija,
      email: mail,
      phoneNumber: telefon,
      employmentType: tipZaposlenja,
      isActive: aktivan,
      department: odjel,
      notes: napomena
    }).then(() => {
      navigate('/dashboard/CompaniesListAll');
    });
  };

  return (
    <div style={{
      backgroundColor: '#001536',  // tamno plava pozadina
      minHeight: '100vh',
      width: '100%',
      padding: '20px'
    }}>
      <Grid container justifyContent="center">
        <Card sx={{ maxWidth: 800, width: '100%', backgroundColor: '#00122E', color: '#ff9800', borderRadius: 2, boxShadow: 3 }}>
          <CardHeader
            avatar={<Avatar sx={{ width: 60, height: 60 }}>{firstName ? firstName[0] : "U"}</Avatar>}
            title={<Typography variant="h6">{firstName} {lastName}</Typography>}
            subheader={<Typography variant="body2">{position}</Typography>}
          />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Ime"
                  value={ime}
                  onChange={(e) => setIme(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                />
                <TextField
                  label="Prezime"
                  value={prezime}
                  onChange={(e) => setPrezime(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                />
                <TextField
                  label="Pozicija"
                  value={pozicija}
                  onChange={(e) => setPozicija(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                />
                <TextField
                  label="Email"
                  value={mail}
                  onChange={(e) => setMail(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                />
                <TextField
                  label="Telefon"
                  value={telefon}
                  onChange={(e) => setTelefon(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Tip zaposlenja"
                  value={tipZaposlenja}
                  onChange={(e) => setTipZaposlenja(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                />
                <FormControlLabel
                  control={<Checkbox checked={aktivan} onChange={() => setAktivan(!aktivan)} sx={{ color: '#ffffff' }} />}
                  label="Aktivan"
                />
                <TextField
                  label="Odjel"
                  value={odjel}
                  onChange={(e) => setOdjel(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                />
                <TextField
                  label="Napomena"
                  value={napomena}
                  onChange={(e) => setNapomena(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  multiline
                  rows={4}
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                />
              </Grid>
            </Grid>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
              <Button variant="outlined"
                sx={{
                  minWidth: 100,
                  backgroundColor: '#001B44',
                  color: '#ff9800',
                  border: '1px solid #ff9800',
                  '&:hover': {
                    backgroundColor: '#001B44',
                    border: '1px solid #ffa726',
                    color: '#ffa726'
                  }
                }}
                onClick={() => navigate(-1)}>
                Odustani
              </Button>
              <Button variant="outlined"
                sx={{
                  minWidth: 100,
                  backgroundColor: '#001B44',
                  color: '#ff9800',
                  border: '1px solid #ff9800',
                  '&:hover': {
                    backgroundColor: '#001B44',
                    border: '1px solid #ffa726',
                    color: '#ffa726'
                  }
                }}
                onClick={updateAPIData}
              >
                Spasi
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
